import {Input} from 'antd'
import React from 'react'
import {useIntl} from 'react-intl'

export type TableSearchFilterProps = {
  filterValue: string
  onFilterValueSet: (value: string) => void
}

export function TableSearchFilter({onFilterValueSet, filterValue}: TableSearchFilterProps) {
  const intl = useIntl()
  return (
    <Input.Search
      allowClear
      enterButton={intl.formatMessage({id: 'filter'})}
      onSearch={onFilterValueSet}
      defaultValue={filterValue}
    />
  )
}
